import { Services, sendingsDefaultWhatsAppButton } from '@sigma-frontend-libs/commons'
import { SendingTypes } from '@sigmasms/shared-types'

import { components } from '@/utils'

import generatorRow from '@/components/generator/row'
import catchSymbolsInput from '@/components/services/sendings/catchSymbolsInput'

function renderWhatsAppButtons(h) {
  return h(
    generatorRow,
    {
      props: {
        value: this.proxy.buttons,
        defaultValue: sendingsDefaultWhatsAppButton,
        max: this.maxButtons
      },
      scopedSlots: {
        row: ({ item }) => {
          return h(
            'div',
            {
              class: `${Services.sendings}-create__form-buttons-button`
            },
            [
              h(
                components['text-field'],
                {
                  props: {
                    value: item.text,
                    label: this.getTranslate(`${Services.sendings}.labels.button.text`),
                    dense: true,
                    details: false
                  },
                  on: {
                    input: event => {
                      item.text = event
                    }
                  }
                }
              ),

              h(
                components['text-field'],
                {
                  props: {
                    value: item.action,
                    label: this.getTranslate(`${Services.sendings}.labels.button.action`),
                    dense: true,
                    details: false
                  },
                  on: {
                    input: event => {
                      item.action = event
                    }
                  }
                }
              )
            ]
          )
        }
      },
      on: {
        input: event => {
          this.proxy.buttons = event
        }
      }
    }
  )
}

function renderViberButton(h) {
  if (this.proxy.button) {
    return h(
      'div',
      {
        class: `${Services.sendings}-create__form-buttons-button`
      },
      [
        h(
          catchSymbolsInput,
          {
            props: {
              value: this.proxy.button.url,
              defaultValue: '',
              label: this.getTranslate(`${Services.sendings}.labels.button.url`),
              hint: this.getTranslate(`${Services.sendings}.hints.button.url`),
              type: 'url',
              dense: true,
              rounded: true,
              error: this.validationButtonUrl,
              tags: this.tags,
              customMenu: this.customMenu
            },
            on: {
              input: event => {
                this.proxy.button.url = event
              }
            }
          }
        ),
        h(
          catchSymbolsInput,
          {
            props: {
              value: this.proxy.button.text,
              defaultValue: '',
              label: this.getTranslate(`${Services.sendings}.labels.button.text`),
              hint: this.getTranslate(`${Services.sendings}.hints.button.text`),
              dense: true,
              rounded: true,
              error: this.validationButtonText,
              tags: this.tags,
              customMenu: this.customMenu
            },
            on: {
              input: event => {
                this.proxy.button.text = event
              }
            }
          }
        )
      ]
    )
  }
}

function renderContent(h, content) {
  return h(
    'div',
    {
      class: `${Services.sendings}-create__form-buttons`
    },
    [ content ]
  )
}

export default function(h) {
  switch (this.type) {
    case SendingTypes.vk:
    case SendingTypes.whatsapp: return renderContent.call(this, h, renderWhatsAppButtons.call(this, h))
    case SendingTypes.viber: return renderContent.call(this, h, renderViberButton.call(this, h))
  }
}
